import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarFilledSize48Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24 0c6 9 15 18 24 24-9 6-18 15-24 24-6-9-15-18-24-24C9 18 18 9 24 0"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HyperstarFilledSize48Glyph.displayName = 'HyperstarFilledSize48Glyph';
